module.exports = "<svg:circle\n  [attr.cx]=\"diameter / 2\"\n  [attr.cy]=\"diameter / 2\"\n  [attr.r]=\"( diameter / 2 ) - ( stroke / 2 )\"\n></svg:circle>\n\n<svg:path\n  [attr.d]=\"path\"\n></svg:path>\n\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/gauge/gauge.component.html
// module id = 1638
// module chunks = 2